import React, { useState } from 'react';
import SearchComponentWeb from './searchComponentWeb';
import { CURRENT_PAGE } from '../../../constant';

const SearchPageWeb = ({ setCurrentPageUnderMenu }) => {
    const [searchKey, setSearchKey] = useState('');

    const handleBack = () => {
        setCurrentPageUnderMenu(CURRENT_PAGE.MAIN);
    };

    const handleClear = () => {
        setSearchKey('');
    };

    return (
        <div style={{ height: '100vh', backgroundColor: '#0b0b0f', color: 'white', overflow: 'hidden' }}>
            {/* Fixed Header */}
            <div style={{
                position: 'fixed',
                top: "60px",
                left: 0,
                right: 0,
                backgroundColor: '#0b0b0f',
                padding: '16px 32px',
                zIndex: 1000,
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
                <button onClick={handleBack} style={{ background: 'none', border: 'none', color: 'white', fontSize: '16px', cursor: 'pointer' }}>
                    ← Back
                </button>
                <div style={{ flexGrow: 1, position: 'relative' }}>
                    <input
                        type="text"
                        placeholder="Search for movies, shows..."
                        value={searchKey}
                        onChange={(e) => setSearchKey(e.target.value)}
                        onKeyUp={(e) => {
                            if (e.key === 'Backspace') setSearchKey(searchKey.slice(0, -1));
                        }}
                        style={{
                            width: '100%',
                            padding: '12px 48px 12px 20px',
                            borderRadius: '8px',
                            backgroundColor: '#1a1a1f',
                            color: 'white',
                            fontSize: '16px',
                            border: 'none',
                            outline: 'none'
                        }}
                    />
                    {searchKey && (
                        <span onClick={handleClear} style={{
                            position: 'absolute',
                            right: '16px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            fontSize: '18px',
                            color: '#aaa'
                        }}>✕</span>
                    )}
                </div>
            </div>

            {/* Content Area */}
            <div style={{
                marginTop: '140px',
                height: 'calc(100vh - 80px)',
                overflowY: 'auto',
                padding: '24px 32px'
            }}>
                <SearchComponentWeb searchKey={searchKey} />
            </div>
        </div>
    );
};

export default SearchPageWeb;
